import { render } from "./TierBadge.vue?vue&type=template&id=504ff3bd"
import script from "./TierBadge.vue?vue&type=script&lang=js"
export * from "./TierBadge.vue?vue&type=script&lang=js"

import "./TierBadge.vue?vue&type=style&index=0&id=504ff3bd&lang=scss"

import exportComponent from "../../../../motom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__